import { Component, Input, OnInit } from '@angular/core';
import { PersonaType } from '@constants/global.enum';
import { DataService } from '@services/hiring-manger-profiledata.service';
import { ActivatedRoute } from '@angular/router';
import {
  VendorProfile,
  strategicPartnership,
} from '@app/shared/constants/global.enum';
import { generateQuarterOptions, getCurrentYear } from '@utils/utils';
import { AuthService } from '@app/core/auth.service';
import { strategicData } from '@app/shared/interfaces/vendor-profile.model';
import { strategicPartnershipDisplayData } from '@app/shared/constants/constants';

type strategicDatas = {
  label: string;
  value: number;
  fileUrl: string;
};

@Component({
  selector: 'app-strategic-partnership',
  templateUrl: './strategic-partnership.component.html',
  styleUrls: ['./strategic-partnership.component.scss'],
})
export class StrategicPartnershipComponent implements OnInit {
  opened = false;
  fieldsVisibility: string = PersonaType.ContractorOrgView;

  @Input() vendorId: string | null = null;
  vendorProfile = VendorProfile;
  strategicPartnership = strategicPartnership;
  quarterOptions: any[] = [];
  preSelectedValue!: string;
  selectedQuarter!: string;
  selectedYear!: string;
  employeeId!: string;
  strategicPartnershipData: strategicData[] = [];

  strategicPartnershipDisplayData: strategicDatas[] =
    strategicPartnershipDisplayData.map((data) => ({ ...data }));

  investmentCount: number = 0;
  userCasesCount: number = 0;

  constructor(
    private dataService: DataService,
    private route: ActivatedRoute,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    const currentYear = parseInt(getCurrentYear());
    this.quarterOptions = generateQuarterOptions(currentYear, 3);
    const preSelectedOption = this.quarterOptions.find(
      (option) => option.selected,
    );
    if (preSelectedOption) {
      this.preSelectedValue = preSelectedOption.value;
      this.selectedQuarter = preSelectedOption.quarter;
      this.selectedYear = preSelectedOption.year;
      this.employeeId = preSelectedOption.employeeId;
    }
    this.loadStrategicPartnership();
  }

  onFilterChange(event: any): void {
    let selectedValue: string | undefined;
    if (typeof event === 'string') {
      const option = this.quarterOptions.find((opt) => opt.label === event);
      selectedValue = option ? option.value : undefined;
    } else if (event.value) {
      selectedValue = event.value;
    }
    if (
      !selectedValue ||
      !this.quarterOptions.some((option) => option.value === selectedValue)
    ) {
      alert(this.vendorProfile.invalidQuarterId);
      return;
    }
    const selectedOption = this.quarterOptions.find(
      (option) => option.value === selectedValue,
    );
    if (selectedOption) {
      this.selectedQuarter = selectedOption.quarter;
      this.selectedYear = selectedOption.year;
      this.preSelectedValue = selectedOption.value;
      this.employeeId = selectedOption.employeeId;
      this.loadStrategicPartnership();
    }
  }

  loadStrategicPartnership(): void {
    if (!this.selectedQuarter || !this.selectedYear || !this.vendorId) {
      return;
    }
    this.authService.getEmployeeDetails().then((employeeData: any) => {
      if (employeeData?.employeeId) {
        this.dataService
          .getStrategicPartnership(
            employeeData?.employeeId,
            parseInt(this.selectedYear),
            this.selectedQuarter,
            this.vendorId,
          )
          .subscribe({
            next: (response) => {
              const data = response?.data || [];
              if (data?.length > 0) {
                  const lastItem = data[data?.length - 1];
                this.strategicPartnershipDisplayData = [
                  {
                    label: 'Investment for Strategic Programs',
                    value: lastItem?.investmentForStrategicPrograms ?? 0,
                    fileUrl: lastItem?.investmentForStrategicProgramsUrl ?? null,
                  },
                  {
                    label: 'Use Cases Co-Invented',
                    value: lastItem?.numberOfUserCasesCoinnovated ?? 0,
                    fileUrl: lastItem?.numberOfUserCasesCoInnovatedUrl ?? null,
                  },
                ];
              }
            },
            error: () => {
              alert(this.vendorProfile.strategicPartnershipNotFound);
            },
          });
      }
    });
  }
}
